const thingsThatMadeYouProud = {
    number: "1/3",
    question: "Clarifying your passion",
    description: `Think of a moment you're most proud of. Especially one that is connected to work that you have done. What kind of work were you doing that made you proud?`
}

const emergedFromCases = {
    number: "2/3",
    question: "Clarifying your passion",
    description: "Explain what emerged from those cases in one sentence, starting with: I am passionate about…"
}

const emergedFromSentence = {
    number: "3/3",
    question: "Clarifying your passion",
    description: "Explain what emerged from the sentence in one word or phrase, starting with: My passion is…"
}

export const questions = {
    thingsThatMadeYouProud: thingsThatMadeYouProud,
    emergedFromCases: emergedFromCases,
    emergedFromSentence: emergedFromSentence,
}

const thingsThatMadeYouProudVideo = {
    url: "https://www.dropbox.com/scl/fi/7g13p0xa4ow0gibvybhmm/5-What-made-you-proud.mp4?rlkey=1xa4i6nfj8ljjvn20tkbqf62c&raw=1"
}

const emergedFromCasesVideo = {
    url: "https://www.dropbox.com/scl/fi/kyks4cj5xjn1n5jts8ea9/6-What-are-you-passionate-about.mp4?rlkey=uec9q08kgahpk2e6n7iuza22c&raw=1"
}

const emergedFromSentenceVideo = {
    url: "https://www.dropbox.com/scl/fi/tth03hufno8fcfmvstswz/7-The-Passion.mp4?rlkey=4r3reednxmyw3oewk6sr5mf71&raw=1"
}

export const videos = {
    thingsThatMadeYouProudVideo: thingsThatMadeYouProudVideo,
    emergedFromCasesVideo: emergedFromCasesVideo,
    emergedFromSentenceVideo: emergedFromSentenceVideo
}